import {
  P,
  Spacing,
  useScopedSelector,
} from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMarkPageLoaded } from 'omni-package-react-core';
import { MfaValidationPageState } from '../../../../interfaces/MfaValidationPageState';
import MfaCodeGeneration from '../../components/MfaCodeGeneration';

export interface MfaEmailStepProps {
}

const MfaEmailStep: FC<MfaEmailStepProps> = () => {
  const { t } = useTranslation('MfaValidationPage');

  const { email } = useScopedSelector(({ values }: MfaValidationPageState) => values.mfa.informations);

  useMarkPageLoaded();

  return (
    <MfaCodeGeneration
      method="email"
      informationType="email"
      submitButtonLabel={t('steps.email.confirmButtonText')}
    >
      <Spacing p-b={12} data-testid="mfaDescription">
        <P><strong>{t('steps.email.description', { information: email })}</strong></P>
      </Spacing>
    </MfaCodeGeneration>
  );
};

export default MfaEmailStep;
